// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"src_app_watermark_watermark_module_ts":"c8d48ea97c88d87c","src_app_products_products_module_ts":"c1acebc86098d654"}[chunkId] + ".js";
};